import { render } from "./Form.vue?vue&type=template&id=f5a241dc&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=f5a241dc&scoped=true&lang=css"

import exportComponent from "D:\\code\\m_pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5a241dc"]])

export default __exports__